import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Recaptcha(props) {
  const { onChangeRecaptcha, recaptchaRef } = props;

  return <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={process.env.REACT_APP_KEY_CAPTCHA} onChange={onChangeRecaptcha} />;
}
